const TicketIcon = ({ className }: { className?: string }) => (
  <svg
    aria-hidden='true'
    version='1.1'
    id='Kontakt'
    width='160'
    height='160'
    xmlns='http://www.w3.org/2000/svg'
    x='0px'
    y='0px'
    viewBox='0 0 172.9106 283.46'
    className={className}
  >
    <path
      fill='currentColor'
      d='M149.6587,225.771l-1.1931-16.7263l24.445-2.0403L156.2213,0l-22.146,1.8476l1.1509,16.122h-0.0125
   c0.7626,10.5688-1.5806,21.4662-7.4256,31.2701c-15.2533,25.5955-48.4885,34.0509-74.2318,18.8842
   c-15.883-9.3559-25.1896-25.5162-26.42-42.5304l-0.0125,0.002l-1.0505-14.7367L0,13.035l16.6893,207.0064l23.7744-1.9835
   l1.0934,15.339l0.045-0.002c1.2242,17.0143,10.5059,33.1766,26.3875,42.5326c25.7425,15.1646,58.9785,6.7112,74.2318-18.8842
   c5.8443-9.8062,8.1758-20.7015,7.4111-31.2703L149.6587,225.771z'
    />
  </svg>
);

export default TicketIcon;
